module.exports = __webpack_public_path__ + "cf2c112ecaa1975cf16df4ec2f704f84.png";